import { gql } from 'graphql-request';

export const PROJECT_FIELDS = gql`
  fragment ProjectFields on ProjectDto {
    projectId
    name
    address
    description
    budget
    totalManHours
    siteImage
    startDate
    endDate
    lat
    long
    clientId
    state
    isBehind
    isFavorited
    projectManagerId
    documents {
      documentId
      name
      category
      url
    }
    tasks {
      taskId
      status
      delegateOrganizationId
      delegateOrganization {
        name
      }
    }
    superintendents {
      employeeId
      dob
      hireDate
      rate
      payPeriod
      mode
      user {
        avatar
        userId
        firstName
        lastName
        email
        role
      }
    }
    reviewers {
      employeeId
      user {
        avatar
        userId
        firstName
        lastName
        email
        role
      }
    }
    projectManager {
      employeeId
      user {
        firstName
        lastName
        email
      }
    }
    client {
      name
      email
    }
    originalProjectId
    originalProject {
      projectId
      name
      organization {
        organizationId
        name
      }
    }
    selfMirror {
      projectId
    }
  }
`;

export const getProjects = gql`
  query getProjects {
    getProjects {
      ...ProjectFields
    }
  }

  ${PROJECT_FIELDS}
`;

export const getProjectsByUser = gql`
  query getProjectsByUser($userId: String, $states: [String!]) {
    getProjectsByUser(userId: $userId, states: $states) {
      ...ProjectFields
    }
  }
  ${PROJECT_FIELDS}
`;

export const getProjectsByUserPaginated = gql`
  query getProjectsByUserPaginated(
    $userId: String!
    $page: Int
    $limit: Int
    $search: String
    $states: [String!]
    $sortBy: String
  ) {
    getProjectsByUserPaginated(
      userId: $userId
      page: $page
      limit: $limit
      search: $search
      states: $states
      sortBy: $sortBy
    ) {
      projects {
        ...ProjectFields
      }
      pagination {
        total
        page
        limit
        totalPages
        hasNext
        hasPrev
      }
    }
  }
  ${PROJECT_FIELDS}
`;

const getProjectById = gql`
  query getProjectById($projectId: String!) {
    getProjectById(projectId: $projectId) {
      ...ProjectFields
    }
  }
  ${PROJECT_FIELDS}
`;

const getProjectsByIds = gql`
  query GetProjectByIDs($projectIds: [String!]!) {
    getProjectByIDs(projectIds: $projectIds) {
      projectId
      name
    }
  }
`;

export const createProject = gql`
  mutation createProject($project: ProjectCreateInput!) {
    createProject(project: $project) {
      ...ProjectFields
    }
  }
  ${PROJECT_FIELDS}
`;

export const updateProject = gql`
  mutation updateProject($project: ProjectUpdateInput!) {
    updateProject(project: $project) {
      ...ProjectFields
    }
  }
  ${PROJECT_FIELDS}
`;

export const deleteProject = gql`
  mutation deleteProject($id: String!) {
    deleteProject(id: $id) {
      affected
      messages
    }
  }
`;

export const updateProjectStatus = gql`
  mutation UpdateProjectStatus($projectId: String!, $status: ProjectStatus!) {
    updateProjectStatus(projectId: $projectId, status: $status) {
      projectId
      name
      state
    }
  }
`;

export const toggleProjectFavorite = gql`
  mutation toggleProjectFavorite($projectId: String!) {
    toggleProjectFavorite(projectId: $projectId)
  }
`;

const ProjectsGraphQL = {
  queries: {
    getProjects,
    getProjectById,
    getProjectsByIds,
    getProjectsByUser,
    getProjectsByUserPaginated,
  },
  mutations: {
    createProject,
    updateProject,
    deleteProject,
    updateProjectStatus,
    toggleProjectFavorite,
  },
};

export default ProjectsGraphQL;
